export const normalizePhone = (phone) => {
  if (!phone) return '';
  const digits = String(phone).replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  return digits;
};

export const buildWhatsAppLink = ({ phone, message }) => {
  const normalizedPhone = normalizePhone(phone);
  if (!normalizedPhone) return '';

  const encodedMessage = encodeURIComponent(message || 'Olá!');
  return `https://wa.me/${normalizedPhone}?text=${encodedMessage}`;
};
